import { render } from "./BaseViewInfoText.vue?vue&type=template&id=5bf149aa&scoped=true"
import script from "./BaseViewInfoText.vue?vue&type=script&lang=js"
export * from "./BaseViewInfoText.vue?vue&type=script&lang=js"

import "./BaseViewInfoText.vue?vue&type=style&index=0&id=5bf149aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf149aa"],['__file',"src/components/helpers/BaseViewInfoText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bf149aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bf149aa', __exports__)) {
    api.reload('5bf149aa', __exports__)
  }
  
  module.hot.accept("./BaseViewInfoText.vue?vue&type=template&id=5bf149aa&scoped=true", () => {
    api.rerender('5bf149aa', render)
  })

}


export default __exports__